import { render, staticRenderFns } from "./ReFileUpload.vue?vue&type=template&id=5a4b648e"
import script from "./ReFileUpload.vue?vue&type=script&lang=js"
export * from "./ReFileUpload.vue?vue&type=script&lang=js"
import style0 from "./ReFileUpload.vue?vue&type=style&index=0&id=5a4b648e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports